<template>
  <div :class="$style['filter']">
    <div :class="$style['filter__title']">
      {{ props.title }}
    </div>

    <div
      v-for="sortOption in props.available"
      :key="sortOption.value"
      class="filter__item"
      tabindex="0"
      :class="[
        $style['filter__item'],
        {
          [$style['filter__item--active']]: props.active === sortOption.value
        }
      ]"
      @click="emit('toggle', sortOption.value)">
      {{ sortOption.title }}
    </div>
  </div>
</template>
<script setup>
const emit = defineEmits(['toggle'])
const props = defineProps({
  title: {
    type: String,
    default: null
  },
  active: {
    type: [Boolean, String],
    default: null
  },
  available: {
    type: [Object, Function, Boolean, String],
    default: null
  }
})
</script>
<style lang="scss" module>
@use './style' as *;

.filter {
  &__item {
    color: var(--grey);
    cursor: pointer;
    font-size: var(--font-size-s);

    &:focus,
    &:hover {
      color: var(--black);
    }

    &--active {
      color: var(--black);
    }
  }
}
</style>
